import axios from 'axios';

// let baseUrl = "http://feige.tangyingchina.com/"
let baseUrl = "https://up.tangyingchina.cn/"
// let baseUrl = "http://127.0.0.1:8081/"
// let baseUrl = "http://127.0.0.1:8082/"
// let baseUrl = "http://shtykjweb.fgimax.vipnps.vip/"
let headersConfig = {
  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
}

var qs = require('qs'); 
// 创建axios 实例
let MainAxios = axios.create({
  baseURL: baseUrl
});

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 **/
export function Get(url, params) {
  if (!params) {
    params = ""
  }
  return new Promise(function (resolve, reject) {
    MainAxios.get(url,params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function Post(url, params) {
  return new Promise((resolve, reject) => {
    if (!params) {
      params = {}
    }
    MainAxios.post(url, qs.stringify(params),{headers:headersConfig}).then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}



// WEBPACK FOOTER //
// ./src/api/http.js